/**
 * Spinner — вращающийся круг brick-цвета (CSS .spinner / .spinner-lg).
 * Используется во время загрузки и где нужен async-индикатор.
 */
interface SpinnerProps {
  size?: "sm" | "md" | "lg";
  label?: string;
}

export function Spinner({ size = "sm", label }: SpinnerProps) {
  if (label) {
    return (
      <div className="loading-screen">
        <div className={size === "lg" ? "spinner spinner-lg" : "spinner"} />
        <div>{label}</div>
      </div>
    );
  }
  return <span className={size === "lg" ? "spinner spinner-lg" : "spinner"} />;
}
